import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo, useRef, useState } from 'react';
import { compact } from 'lodash-es';
import { BottomSheetContentLayout } from '../BottomSheet';
import { useOverlayContext } from '../OverlayContext';
import { MobileSummaryCard } from '../TextField/MobileSummaryCard';
import { Typography } from '../Typography';
import { BaseRichTextEditor, extractPureTextFromRichText } from './BaseRichTextEditor';
import styles from './MobileRichTextEditor.module.scss';
import { GetMobileRichTextEditorTID } from './RichTextEditor.utils';
function RichTextEditorInBottomSheet(props) {
    var _ref;
    const { mobile } = props, restProps = _object_without_properties(props, [
        "mobile"
    ]);
    const { validateInBottomSheet } = mobile !== null && mobile !== void 0 ? mobile : {};
    const { hideBottomSheet } = useOverlayContext();
    const [tempValue, setTempValue] = useState(props.initialValue);
    const hasChangedRef = useRef(false);
    const validationResult = validateInBottomSheet === null || validateInBottomSheet === void 0 ? void 0 : validateInBottomSheet(tempValue);
    const error = validationResult ? validationResult.error : props.error;
    const helperText = validationResult ? validationResult.helperText : props.helperText;
    function handleSave() {
        if (hasChangedRef.current && props.onChange) {
            props.onChange(tempValue);
        }
        hideBottomSheet();
    }
    return /*#__PURE__*/ _jsx(BottomSheetContentLayout, {
        contentClassName: styles.bottomSheetContent,
        footer: {
            primaryAction: {
                text: (_ref = mobile === null || mobile === void 0 ? void 0 : mobile.saveButtonLabel) !== null && _ref !== void 0 ? _ref : 'Save',
                onClick: ()=>handleSave(),
                noBi: true
            }
        },
        children: /*#__PURE__*/ _jsx(BaseRichTextEditor, _object_spread_props(_object_spread({}, restProps), {
            initialValue: tempValue,
            error: error,
            helperText: helperText,
            onChange: (value)=>{
                hasChangedRef.current = true;
                setTempValue(value);
            },
            helperTextReserveSpace: true,
            className: styles.editorFillHeight
        }))
    });
}
export function MobileRichTextEditor(props) {
    const { testId, error, helperText, initialValue, disabled, isReadOnly, mobile } = props;
    const { pushBottomSheetPage } = useOverlayContext();
    const { MobileRichTextEditorTID } = useMemo(()=>GetMobileRichTextEditorTID(testId), [
        testId
    ]);
    const plainTextPreview = useMemo(()=>extractPureTextFromRichText(initialValue), [
        initialValue
    ]);
    return /*#__PURE__*/ _jsx(MobileSummaryCard, {
        testId: testId,
        items: [
            {
                title: mobile === null || mobile === void 0 ? void 0 : mobile.summaryLabel,
                titleTestId: MobileRichTextEditorTID.Label(),
                body: /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            ellipsis: true,
                            testId: MobileRichTextEditorTID.Value(),
                            skin: error ? 'error' : 'standard',
                            children: plainTextPreview
                        }),
                        helperText && /*#__PURE__*/ _jsx(Typography, {
                            testId: MobileRichTextEditorTID.HelperText(),
                            skin: error ? 'error' : 'secondary',
                            children: helperText
                        })
                    ]
                }),
                actions: compact([
                    !disabled && !isReadOnly && {
                        type: 'edit',
                        testId: MobileRichTextEditorTID.EditButton(),
                        onClick: ()=>{
                            pushBottomSheetPage({
                                content: /*#__PURE__*/ _jsx(RichTextEditorInBottomSheet, _object_spread({}, props))
                            });
                        },
                        noBi: true
                    }
                ])
            }
        ]
    });
}
